/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { tab_env, tab_securite, options, tab_orientation } from "./Correspondances";

export function Titre({children}) {
	return <span style={{fontFamily: 'JTMarnieBold', fontSize: '160%'}}>{children}</span>;
}

export function Item({children}) {
	return <span style={{fontFamily: 'JTMarnieBold', fontSize: '100%'}}>{children}</span>;
}

export function ComputeSurface({largeur, hauteur}) {
	let surface = largeur*hauteur;
	return <span>Surface : {(surface/1e6).toFixed(2)}m²</span>;
	// if (surface >= 350*600 && surface/1e6 <= 2) {
	// 	return <span>Surface : {(surface/1e6).toFixed(2)}m²</span>;
	// }
	// else if (surface/1e6 > 2) {
	// 	return (
	// 		<Row style={{ 'color': 'red' }}>
	// 		<span>Surface : {(surface/1e6).toFixed(2)}m²</span>
	// 		<span style={{ 'fontFamily': 'JTMarnieBold' }}>La surface doit être inférieure à 2m²</span>
	// 		</Row>
	// 	);
	// }
	// else return (
	// 	<Row style={{ 'color': 'red' }}>
	// 		<span>Surface : {(surface/1e6).toFixed(2)}m²</span>
	// 		<span style={{ 'fontFamily': 'JTMarnieBold' }}>La surface doit être supérieure à 350mm x 600mm</span>
	// 	</Row>
	// );
}

export function ComputeEnv(securite, env) {
	if ((env === 1) || ((securite === 1 || securite === 2) && env === 2)) {
		return [0, "Votre configuration actuelle est adaptée à un environnement " + tab_env[env-1]];
	}
	else if ((securite === 1 || securite === 2) && env === 3) {
		return [1, "En adaptant votre configuration à un environnement " + tab_env[env-1] + ", vous obtenez une Sécurité Complète"];
	}
	else if (securite === 0 && env === 3) {
		return [2, "En adaptant votre configuration à un environnement " + tab_env[env-1] + ", vous obtenez une Sécurité Effraction"];
	}
	else if (securite === 0 && env === 2) {
		return [3, "En adaptant votre configuration à un environnement " + tab_env[env-1] + ", vous obtenez une Sécurité Éclats"];
	}
	else if (securite === 3) {
		return [4, "Votre configuration est adaptée à un environnement " + tab_env[env-1]];
	}
	else return -1;
}

export function ComputeVerres(securite, radioValueEnv, orientation) {
	if (ComputeEnv(securite, radioValueEnv)[0] === 0) {
		return [tab_securite[securite][0], tab_securite[securite][1] + (orientation === 0 ? "rTherm" : "rSun")];
	}
	else if (ComputeEnv(securite, radioValueEnv)[0] === 1) {
		return [tab_securite[3][0], tab_securite[3][1] + (orientation === 0 ? "rTherm" : "rSun")];
	}
	else if (ComputeEnv(securite, radioValueEnv)[0] === 1) {
		return [tab_securite[3][0], tab_securite[3][1] + (orientation === 0 ? "rTherm" : "rSun")];
	}
	else if (ComputeEnv(securite, radioValueEnv)[0] === 2) {
		return [tab_securite[2][0], tab_securite[2][1] + (orientation === 0 ? "rTherm" : "rSun")];
	}
	else if (ComputeEnv(securite, radioValueEnv)[0] === 3) {
		return [tab_securite[1][0], tab_securite[1][1] + (orientation === 0 ? "rTherm" : "rSun")];
	}
	else if (ComputeEnv(securite, radioValueEnv)[0] === 4) {
		return [tab_securite[3][0], tab_securite[3][1] + (orientation === 0 ? "rTherm" : "rSun")];
	}
	else return -1;
}

export function ComputeTarif(tarifs, surface, securite, radioValueEnv, store_type, commande, orientation) {
	if (surface < 0.5) { // Tarifs toujours calculé pour minimum 0.5m²
		surface = 0.5;
	}

	let surface_vitrage = surface + ((tarifs["marge_surface"]*2)**2)/1e6;
	let prix_verre = surface_vitrage * (tarifs[ComputeVerres(securite, radioValueEnv, orientation)[0]] + tarifs[ComputeVerres(securite, radioValueEnv, orientation)[1]]);
	
	let prix_store = tarifs[store_type === 0 ? 'lames' : "blackout"] + tarifs[options[commande]];
	
	return (prix_verre + prix_store) | 0; // bitwise comparaison : arrondi à l'entier supérieur
}

export function ComputeHorsNormes(largeur, hauteur, store_type, commande) {
	let surface = largeur*hauteur/1e6;

	if (store_type === 0) { // 0 = lames, 1 = blackout
		if (surface < 0.2 || surface > 2)
			return true;
		else if (largeur < 300 || largeur > 2000)
			return true;
		else if (hauteur < 300 || hauteur > 2200)
			return true;
		else if (commande === 0 || commande === 1) { // 0 ou 1 = manuelle, 2 = moteur
			if (largeur >= 300 && largeur <= 350 && hauteur > 850)
				return true;
			else if (largeur >= 351 && largeur <= 400 && hauteur > 1550)
				return true;
			else if (largeur >= 401 && largeur <= 450 && hauteur > 1950)
				return true;
			else if (largeur >= 451 && largeur <= 2000 && hauteur > 2200)
				return true;
			else return false; //* cas nominal
		}
		else if (commande === 2) { // moteur
			if (largeur >= 300 && largeur <= 350 && hauteur > 1670)
				return true;
			else if (largeur >= 351 && largeur <= 400 && hauteur > 2020)
				return true;
			else if (largeur >= 401 && largeur <= 2000 && hauteur > 2200)
				return true;
			else return false; //* cas nominal
		}
		else return true; //! cas impossible en théorie
	}
	else if (store_type === 1) { // blackout
		if (commande === 0 || commande === 1) { // 0 ou 1 = manuelle, 2 = moteur
			if (surface < 0.2 || surface > 1.2)
				return true;
			else if (largeur < 300 || largeur > 800)
				return true;
			else if (hauteur < 300 || hauteur > 1800)
				return true;
			else return false; //* cas nominal
		}
		else if (commande === 2) { // moteur
			if (surface < 0.2 || surface > 2)
				return true;
			else if (largeur < 300 || largeur > 1200)
				return true;
			else if (hauteur < 300 || hauteur > 2200)
				return true;
			else if (largeur >= 300 && largeur <= 350 && hauteur > 1670)
				return true;
			else if (largeur >= 351 && largeur <= 400 && hauteur > 2020)
				return true;
			else if (largeur >= 401 && largeur <= 2000 && hauteur > 2200)
				return true;
			else return false; //* cas nominal
		}
		else return true; //! cas impossible en théorie
	}
	else return true; //! cas impossible en théorie
}

export function WindowHeight(isPortrait, HorsNormes) {
	if (isPortrait && (window.innerWidth > 700))
		return window.innerHeight*0.88 | 0;
	else if (isPortrait && !HorsNormes)
		return window.innerHeight/2.5 | 0;
	else if (isPortrait && HorsNormes)
		return window.innerHeight/1.8 | 0;
	else
		return window.innerHeight*0.85 | 0;
}

export function ConvSecu(secu, computeenv, orientation) {
	if (computeenv === 0 || computeenv === 4) // pas de changement dû à l'env, sécurité choisie par le client
		return [secu, tab_securite[secu][0], tab_securite[secu][1] + tab_orientation[orientation]];
	else if (computeenv === 3)
		return [1, tab_securite[1][0], tab_securite[1][1] + tab_orientation[orientation]]; // sécu éclats, ["33.2rSonic", "4"] --> "33.2rSonic 4"
	else if (computeenv === 2)
		return [2, tab_securite[2][0], tab_securite[2][1] + tab_orientation[orientation]]; // sécu effraction
	else if (computeenv === 1)
		return [3, tab_securite[3][0], tab_securite[3][1] + tab_orientation[orientation]]; // sécu complète
	else // -1
		return [-1, "Erreur", "Erreur"];
}
